<app-page-shell 
    [title]="(currentTab === 'list' ? 'rooms_tab_list' :
             currentTab === 'unavailable' ? 'rooms_tab_unavailable' :
             currentTab === 'workload' ? 'rooms_tab_workload' :
             'rooms_tab_occupancy') | translate">
    
    <!-- Tabs Navigation -->
    <!-- One-way, deliberately: the ?tab= query param is the source of truth and
         currentTab is only ever written from it. A two-way [(activeValue)] would
         set currentTab before selectTab ran, so the "already on this tab" guard
         would swallow the navigation and the URL would never update. -->
    <div class="mb-8">
        <app-tabs
            [items]="tabItems"
            [activeValue]="currentTab"
            (activeValueChange)="selectTab($event)">
        </app-tabs>
    </div>

    <!-- Tab Content -->
    <div class="animate-in fade-in slide-in-from-bottom-4 duration-500">
        <!-- List of Rooms Tab -->
        <app-list-of-rooms *ngIf="currentTab === 'list'"></app-list-of-rooms>

        <!-- Rooms Not Available Tab -->
        <app-rooms-not-available *ngIf="currentTab === 'unavailable'"></app-rooms-not-available>

        <!-- Occupancy Report Tab -->
        <app-occupancy-report *ngIf="currentTab === 'occupancy'"></app-occupancy-report>

        <!-- Workload Report Tab -->
        <app-workload-report *ngIf="currentTab === 'workload'"></app-workload-report>
    </div>
</app-page-shell>